<template>
  <div>
    <drop-down :multiLevel="true">
      <md-button class="md-button md-info dropdown-toggle md-block">
        <img
          src="/img/green-dot.png"
          class="status-icon"
          title="Online"
          v-if="selectedDevice.status === 'ONLINE'"
        />
        <img
          src="/img/red-dot.png"
          class="status-icon"
          title="Offline"
          v-if="selectedDevice.status === 'OFFLINE'"
        />

        <span class="item-icon">
          <i
            class="fa fa-charging-station"
            v-if="selectedDevice.isLeaf && selectedDevice.type === 1"
          ></i>
        </span>
        {{selectedDevice.title}}
      </md-button>

      <div class="dropdown-menu">
        <sl-vue-tree
          v-model="nodes"
          ref="slVueTree"
          :allowMultiselect="false"
          @select="nodeSelected"
          @drop="nodeDropped"
          @toggle="nodeToggled"
        >
          <template slot="title" slot-scope="{ node }">
            <span v-if="node.isLeaf">
              <img
                src="/img/green-dot.png"
                class="status-icon"
                title="Online"
                v-if="node.data.status === 'ONLINE'"
              />
              <img src="/img/red-dot.png" class="status-icon" title="Offline" v-else />
            </span>

            <span class="item-icon">
              <i
                class="fa fa-charging-station"
                v-if="node.isLeaf && (node.data.type === 1 || !node.data.type)"
              ></i>
              <i class="fa fa-toggle-on" v-if="node.isLeaf === true && node.data.type === 2"></i>
              <i class="fas fa-suitcase" v-if="node.isLeaf === true && node.data.type === 3"></i>
              <i class="fa fa-home" v-if="!node.isLeaf"></i>
            </span>
            {{ node.title }}
          </template>

          <template slot="toggle" slot-scope="{ node }">
            <span v-if="!node.isLeaf">
              <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
              <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
            </span>
          </template>

          <template slot="sidebar" slot-scope="{ node }">
            <md-chips
              v-model="menuTags[getTagIndex(node.data.id)].tags"
              class="md-primary"
              :md-limit="1"
              :md-placeholder="$lang.inputs.add_tag"
              :md-static="node.isLeaf ? true : false"
            ></md-chips>
          </template>

          <template slot="draginfo">{{selectedDevice.title}}</template>
        </sl-vue-tree>
      </div>
    </drop-down>

    <md-snackbar :md-duration="5000" :md-active.sync="snackBarVisible">
      <span>{{snackBarMessage}}</span>
      <md-button class="md-info md-simple" @click="snackBarVisible = false">{{$lang.keys.close}}</md-button>
    </md-snackbar>
  </div>
</template>


<script>
import { getUserToken } from "@/storage/memoryStorage";
import SlVueTree from "sl-vue-tree";
import { Modal } from "@/components";
import axios from "axios";
import Swal from "sweetalert2";

const focus = {
  inserted(el) {
    el.focus();
  }
};

export default {
  name: "devices-menu",
  directives: { focus },
  components: {
    "sl-vue-tree": SlVueTree,
    Modal
  },
  data() {
    return {
      selectedDevice: {},
      snackBarMessage: "",
      snackBarVisible: false,
      nodes: [],
      menuTags: [],
      treeFind: false
    };
  },

  created() {
    this.getDeviceList();
  },

  mounted() {},

  methods: {
    getDeviceLabel(deviceTypeID) {
      switch (deviceTypeID) {
        case 1:
          return "MeriTo";
        case 2:
          return "Disconnector";
        case 3:
          return "PTE2300E";
        case 12:
          return "EYMON";
        default:
          return "MeriTo";
      }
    },

    getTagIndex(id) {
      let ret = null;
      ret = this.menuTags.findIndex(tag => tag.id == id);
      return ret;
    },

    iterateOverTree(parent) {
      if (parent) {
        parent.forEach(profile => {
          if (profile.children) {
            this.iterateOverTree(profile.children);
          } else {
            if (profile.isLeaf) {
              
              if (!this.treeFind) {
                this.selectedDevice = {
                  title: profile.title,
                  mac: profile.data.mac,
                  isLeaf: profile.isLeaf,
                  type: profile.data.type,
                  status: profile.data.status,
                  token: profile.data.token
                };

                this.$emit("on-selected", this.selectedDevice);
                this.treeFind = true;
              }
            }
          }
        });
      }
    },

    setDefaultSelected() {
      if (this.nodes.length === 0) {
        this.selectedDevice = {
          title: this.$lang.general.no_device,
          mac: null,
          isLeaf: null,
          type: null,
          status: null,
          token: null
        };
        this.$emit("on-selected", this.selectedDevice);
      } else {
        this.treeFind = false;
        this.iterateOverTree(this.nodes);
      }
    },

    getDeviceList() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applications/accutest/device-list",
        data: {
          user_token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.forEach((device, index) => {
            this.nodes.push({
              title: device.mac,
              isLeaf: true,
              data: {
                id: index + 1,
                mac: device.mac,
                type: device.type,
                token: device.token,
                status: device.status
              }
            });

            this.menuTags.push({
              id: index + 1,
              title: device.mac,
              mac: device.mac,
              tags: [this.getDeviceLabel(device.type)]
            });
          });
          this.setDefaultSelected();
        })
        .catch(error => {
          this.showSnackBar(this.$lang.messages.api_communication_error);
        });
    },

    showSnackBar(msg) {
      this.snackBarMessage = msg;
      this.snackBarVisible = true;
    },

    nodeSelected(nodes, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      // slVueTree.traverse((node, nodeModel, path) => {
      //   let nodeData = Object.assign({}, node.data);
      //   nodeData.isEdited = false;

      //   slVueTree.updateNode(node.path, {
      //     data: nodeData
      //   });
      // });

      const isNodeLeaf = nodes.map(node => node.isLeaf)[0];

      if (isNodeLeaf === true) {
        const newSelectedDevice = {
          title: nodes.map(node => node.title).join(", "),
          mac: nodes.map(node => node.data.mac).join(", "),
          isLeaf: isNodeLeaf,
          type: Number(nodes.map(node => node.data.type).join(", ")),
          status: nodes.map(node => node.data.status).join(", "),
          token: nodes.map(node => node.data.token).join(", ")
        };
        if (
          JSON.stringify(this.selectedDevice) !==
          JSON.stringify(newSelectedDevice)
        ) {
          this.selectedDevice = newSelectedDevice;
          this.$emit("on-selected", this.selectedDevice);
        }
      }
    },

    nodeDropped(nodes, position, event) {},

    nodeToggled(node, event) {}
  }
};
</script>


<style lang="scss" scoped>
i {
  width: 33px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}

.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.hierarchy-new-object {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.md-button {
  height: 40px;
}

.md-card-actions .md-layout-item {
  padding: 0;
}

.md-chips.md-field {
  padding: 0;
  margin: 0;
}

.items-inline {
  display: inline;
}

.md-button.md-just-icon {
  height: 35px;
}

@media only screen and (min-width: 500px) {
  .dropdown-menu {
    width: 400px;
  }
}

@media only screen and (min-width: 550px) {
  .dropdown-menu {
    width: 450px;
  }
}

@media only screen and (max-width: 450px) {
  .dropdown-menu {
    left: -55px;
  }
}

.dropdown-menu {
  min-width: 350px;
}

.status-icon {
  width: 10px;
  height: auto;
  /*   margin-right: 12px;  */
}
</style>


<style lang="scss">
@import "./src/assets/scss/md/_variables";

.modal-container {
  color: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  );
}

.md-chips.md-field .md-input {
  max-width: 90px;
}

.sl-vue-tree.sl-vue-tree-root {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  background-color: #ffffff;
  color: #414d5c;
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: #ffffff;
  color: #414d5c;
}
.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  background-color: $green-300;
  color: #ffffff;
  cursor: pointer;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 35px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 500px) {
  .sl-vue-tree-gap {
    width: 10px;
    min-height: 1px;
  }
}

@media only screen and (min-width: 500px) {
  .sl-vue-tree-gap {
    width: 25px;
    min-height: 1px;
  }
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: $green-400;
  opacity: 0.85;
  margin-left: 20px;
  padding: 5px 10px;
}

.item-icon {
  display: inline-block;
  text-align: left;
  /* width: 20px;
  padding-right: 7px; */
}
</style>

